const events = {
  messageAdded: [],
  conversationAdded: [],
  typingStarted: [],
  typingEnded: [],
}

/**
 * This class is a mock of `@twilio/conversations` Client class. It allows for testing the event based messaging features.
 * It is meant to be used through the `receiveMessage` Cypress command defined in `cypress/support/commands.js`
 */
export class TwilioConversationsMock {
  events: any

  constructor() {
    this.events = events
  }

  /**
   * Hacked mock function to make sure this class is created
   * just once
   * @param accessToken
   */
  mockCreated = (accessToken: string) => {
    console.log(`'mock created with ${accessToken}`)
  }

  on(eventName: any, callback: any) {
    if (!this.events[eventName]) {
      this.events[eventName] = []
    }
    this.events[eventName].push(callback)
  }

  off(eventName: any, callback: any) {
    const index = this.events[eventName]?.indexOf(callback) ?? -1
    if (index !== -1) {
      this.events[eventName].splice(index, 1)
    }
  }

  trigger(eventName: any, params: any) {
    this.events[eventName].forEach((callback: any) => callback(params))
  }

  getConversationBySid() {
    return { typing: () => ({}) }
  }

  get user(): { identity: string } {
    return {
      identity: 'test',
    }
  }

  removeAllListeners(): void {
    this.events = events
  }
}
